import Vue from 'vue'
import App from './App.vue'
import './quasar'
import router from './router'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueCookie from 'vue-cookie'

Vue.use(Vuex)
Vue.config.productionTip = false
Vue.use(VueAxios, axios)
Vue.use(VueCookie);

const store = new Vuex.Store({
  state: {
    language: 'en',
    pages : [],
    // env: (process.env.VUE_APP_ENV).trim()
  },
  mutations: {
    setLanguage(state, language){
      state.language = language
    }
  }
})

new Vue({
  router,
  store,
  components: {
  },
  render: h => h(App),
}).$mount('#app')
